import { FC, ReactElement } from "react";
import {
  Stack,
  Tabs,
  TabList,
  Tab,
  TabPanels,
  TabPanel,
  Flex,
} from "@chakra-ui/react";

interface TabComponentProps {
  tabs: string[];
  panels: ReactElement[];
  headingElement?: JSX.Element;
}

const TabComponent: FC<TabComponentProps> = ({
  tabs,
  panels,
  headingElement,
}) => {
  return (
    <Stack spacing={8}>
      {headingElement && (
        <Flex direction="column" gap={4}>
          {headingElement}
        </Flex>
      )}
      <Tabs
        onChange={() => {
          setTimeout(() => {
            window.dispatchEvent(new Event("resize"));
          }, 100);
        }}
      >
        <Stack gap={8}>
          <TabList>
            {tabs.map((tab, index) => (
              <Tab key={index}>{tab}</Tab>
            ))}
          </TabList>

          <TabPanels>
            {panels.map((panel, index) => (
              <TabPanel key={index} p={0}>
                {panel}
              </TabPanel>
            ))}
          </TabPanels>
        </Stack>
      </Tabs>
    </Stack>
  );
};

export default TabComponent;
